import { LuIcon, Text } from "@overmap-ai/blocks"
import type { GeoImage, Stored } from "@overmap-ai/common"
import { forwardRef, memo } from "react"

import { GeoImageIndexLabel } from "../../../components/IndexLabels/GeoImageIndex"
import { modelIconMapping } from "../../../mappings/icons"
import {
	MentionListEmpty,
	MentionListItem,
	type MentionListRef,
	MentionListRoot,
	type MentionListRootProps,
} from "../../blocks"

type GeoImageMentionListProps = MentionListRootProps<Stored<GeoImage>>

export const GeoImageMentionList = memo(
	forwardRef<MentionListRef<Stored<GeoImage>>, GeoImageMentionListProps>((props, ref) => {
		const { items } = props

		return (
			<MentionListRoot<Stored<GeoImage>> ref={ref} {...props}>
				{items.map((geoImage) => (
					<MentionListItem<Stored<GeoImage>> item={geoImage} key={geoImage.uuid}>
						<LuIcon icon={modelIconMapping.camera} className="inline size-4" />
						<GeoImageIndexLabel geoImageId={geoImage.uuid} />
						<Text className="truncate" accentColor="base">
							{geoImage.title || geoImage.file_name || "Untitled image"}
						</Text>
					</MentionListItem>
				))}
				<MentionListEmpty>No results</MentionListEmpty>
			</MentionListRoot>
		)
	}),
)
GeoImageMentionList.displayName = "GeoImageMentionList"
